import React from 'react';
import { useHistory } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { Well, FormHeading, Form } from '../../../form';
import schema from '../form/schema';
import ThemeForm, { IThemeFormValues } from '../form';
import createTheme from './createTheme';
import WelcomePageFactory from '../form/WelcomePageFactory';

const initialValues: IThemeFormValues = {
  name: '',
  logoUrl: '/CaptureItLogo.png',
  delayInSeconds: 5,
  signInButtonColor: '#307b5c',
  signInTextColor: '#ffffff',
  signOutButtonColor: '#c00000',
  signOutTextColor: '#ffffff',
  welcomePages: [{ ...WelcomePageFactory.Create(), text: 'Welcome to VisIT' }],
};

export const CreateThemePage: React.FC = () => {
  const history = useHistory();

  return (
    <Container fluid>
      <Well>
        <FormHeading title="Theme" subTitle="Create" backPath="/admin/themes" />
        <Form
          initialValues={initialValues}
          promise={createTheme}
          validationSchema={schema}
          onSubmit={() => history.push('/admin/themes')}
        >
          <ThemeForm createMode />
        </Form>
      </Well>
    </Container>
  );
};
